export default __webpack_public_path__ + "static/media/41-min.633fcbdd.png";